import React, { useState } from "react";
import { adminConfigs } from "@thewebops/admin-panel";
import UserTraffic from "../UserTraffic";
import ProgramEndedTag from "../ProgramEndedTag";
import { ConversationHeaderWrapper, MemberPhoto, UserTrafficWrapper } from "./styled";

// The same placeholder the chat shows next to messages from a member without a photo.
const avatarPlaceHolder = "https://res.cloudinary.com/webopsv2/image/upload/v1636280162/images_raevqs.png";

const ConversationHeader = ({ conversation }) => {
  const participant = conversation?.target_participation?.participant || {};
  // Resolved as for the photos next to the member's messages, so the two always match.
  const { resolveUserImage } = adminConfigs.getConfigs().chatConfigs.chatOpsWeb;
  const imageUrl = resolveUserImage(participant);
  // A photo that fails to load (a missing file) falls back to the placeholder. The failed link is remembered, not a
  // flag, so another member's photo is tried again.
  const [failedUrl, setFailedUrl] = useState(null);
  const showPhoto = imageUrl && imageUrl !== failedUrl;

  return (
    <ConversationHeaderWrapper>
      <MemberPhoto
        src={showPhoto ? imageUrl : avatarPlaceHolder}
        alt=""
        onError={() => showPhoto && setFailedUrl(imageUrl)}
      />
      <span>{participant.name}</span>
      <UserTrafficWrapper>
        <UserTraffic width="10px" height="10px" value={participant.last_active_at} />
      </UserTrafficWrapper>
      <ProgramEndedTag participant={participant} />
    </ConversationHeaderWrapper>
  );
};

export default ConversationHeader;
